/* AWSReservedInstances.js
 *
 * For scripts executed on the AWS Billing Tab to show and summarize reserved instance recommendations
 * Copied and modified from: static_src/js/c2Archive/AWSReservedInstances.js
 */

(function (c2, $) {
  'use strict';

  var logger = c2.logging.getLogger('AWSReservedInstances');

  function init(url, tableSelector, containerSelector, $submitButton, $form) {

    function addSumTableFooter(tfoot, data, start, end, display, sum_col) {
      var intVal = function (i) {
        return typeof i === 'string' ?
          i.replace(/[\$,]/g, '') * 1 :
          typeof i === 'number' ? i : 0;
      };

      var total_savings = 0;
      for (var i = 0; i < data.length; i++) {
        total_savings += intVal(data[i][sum_col]);
      }

      $(tfoot).find('th').eq(0).html("Total Estimated Savings: $" + total_savings.toFixed(2));
    }

    // Initial load of the recommendations summary + table
    c2.spinners.showSpinner({selector: containerSelector, fade: true});
    $submitButton.prop('disabled', 'disabled');

    $.ajax({
      url: url,
      dataType: 'html',
      type: "GET",
      success: function (response) {
        $(containerSelector).html(response);
        $(tableSelector).dataTable({
          "aaSorting": [[6, "desc"]],
          "footerCallback": function (tfoot, data, start, end, display) {
            addSumTableFooter(tfoot, data, start, end, display, 6);
          }
        });
        c2.spinners.hideSpinner({selector: containerSelector, fade: true});
        $submitButton.prop('disabled', '');
      },
      error: function (xhr, errmsg, err) {
        logger.debug('Error handling GET request: ' + xhr + '  ' + errmsg + '  ' + err);
        c2.spinners.hideSpinner({selector: containerSelector, fade: true});
        $submitButton.prop('disabled', '');
      }
    });

    // When a user wants to get recommendations from new parameters using the form
    $submitButton.on('click', function (event) {
      event.preventDefault();

      c2.spinners.showSpinner({selector: containerSelector, fade: true});
      $submitButton.prop('disabled', 'disabled');

      var formData = $form.serializeArray();

      $.ajax({
        url: url,
        dataType: 'html',
        type: "POST",
        data: formData,
        success: function (response) {
          $(tableSelector).DataTable().clear().destroy();
          $(containerSelector).html(response);
          $(tableSelector).dataTable({
            "aaSorting": [[6, "desc"]],
            "footerCallback": function (tfoot, data, start, end, display) {
              addSumTableFooter(tfoot, data, start, end, display, 6);
            }
          });
          c2.spinners.hideSpinner({selector: containerSelector, fade: true});
          $submitButton.prop('disabled', '');
        },
        error: function (xhr, errmsg, err) {
          logger.debug('Error handling POST request: ' + xhr + '  ' + errmsg + '  ' + err);
          c2.spinners.hideSpinner({selector: containerSelector, fade: true});
          $submitButton.prop('disabled', '');
        }
      });
    });
  }

  c2.AWSReservedInstances = {
    init: init
  };
})(window.c2, window.jQuery);
